import { useState, useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import './UserNav.css';
import { AuthContext } from '../../contexts/AuthContext';


function UserDropdown({ userNavItems }) {
  const [isOpen, setIsOpen] = useState(false);
  const [userLetter, setUserLetter] = useState('.');
  const dropdownRef = useRef(null);
  const { userInfo } = useContext(AuthContext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (userInfo) {
      setUserLetter(userInfo.username.length ? userInfo.username[0].toUpperCase() : '.');
    };
  }, [userInfo]);

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button className="common-button user-icon" onClick={() => setIsOpen(!isOpen)}>{userLetter}</button>
      <div className={`dropdown-menu ${isOpen ? 'active' : 'inactive'}`}>
        {userNavItems.map((item) => (
          <DropdownItem props={item} />
        ))}
      </div>
    </div>
  );
}

function DropdownItem({ props }) {
  return (
    props.link ?
    <Link to={props.link} style={{textDecoration: 'none'}} >
      <button className="common-button dropdown-item" onClick={props.onClick}>
        <span className="material-symbols-outlined">{props.icon}</span>
        <p>{props.text}</p>
      </button>
    </Link> :
    <button className="common-button dropdown-item" onClick={props.onClick}>
      <span className="material-symbols-outlined">{props.icon}</span>
      <p>{props.text}</p>
    </button>
  )
}

export default UserDropdown;
